export enum ContentType {
    audio,
    video,
    text,
    image
}
